import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import './index.css';
import reportWebVitals from './reportWebVitals';

const Home = lazy(() => import('./Layout/Pages/Home'));
const Serial = lazy(() => import('./Layout/Pages/Verify/Serial'));
const Serialnumber = lazy(() => import('./Layout/Pages/Verify/Serialnumber'));
const Serialnumbergenuine = lazy(() => import('./Layout/Pages/Verify/Serialnumbergenuine'));
const Serialgp10 = lazy(() => import('./Layout/Pages/gp10/Serialgp10'));
const Serialnumbergenuinegp10 = lazy(() => import('./Layout/Pages/gp10/Serialnumbergenuinegp10'));
const Homeg10 = lazy(() => import('./Layout/Pages/gp10/Homeg10'));
const Nodata = lazy(() => import('./Layout/Pages/gp10/Nodata'));
const Pureghee900ml = lazy(() => import('./Layout/Pages/pureghee900ml/Pureghee900ml'));
const Pureghee450ml = lazy(() => import('./Layout/Pages/Verify/Pureghee450ml'));
const Cowghee = lazy(() => import('./Layout/Pages/Verify/Cowghee'));

function PageLoader() {
  return (
    <div className="page-loader" role="status" aria-label="Loading">
      <div className="page-loader-spinner" />
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <main>
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/:qrCode" element={<Serial />} />
        <Route path="/serial" element={<Serialnumber />} />
        <Route path="/not-found/" element={<Serialnumbergenuine />} />

        <Route path="/gp10/" element={<Homeg10 />} />
        <Route path="/gp10/:qrCode" element={<Serialgp10 />} />
        <Route path="/gp10/not-found/:qrCode" element={<Serialnumbergenuinegp10 />} />
        <Route path="/gp10/invalid-coupon-code/" element={<Nodata />} />

        <Route path="/mt-pure-ghee-900ml" element={<Home />} />
        <Route path="/mt-pure-ghee-900ml/:qrCode" element={<Pureghee900ml />} />
        <Route path="/mt-pure-ghee-900ml/invalid-coupon-code" element={<Nodata />} />

        <Route path="/pure-ghee-450ml" element={<Home />} />
        <Route path="/pure-ghee-450ml/:qrCode" element={<Pureghee450ml />} />
        <Route path="/pure-ghee-450ml/invalid-coupon-code" element={<Nodata />} />

        <Route path="/cow-ghee" element={<Home />} />
        <Route path="/cow-ghee/:qrCode" element={<Cowghee />} />
        <Route path="/cow-ghee/invalid-coupon-code" element={<Nodata />} />
      </Routes>
    </Suspense>
    </main>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
